import Loadable from "../components/Common/Loadable";

const DaftarUjian = Loadable(() => import('../views/Ujian/DaftarUjian/DaftarUjian'));
const UjiTunggu = Loadable(() => import('../views/Ujian/UjiTunggu/UjiTunggu'));
const PerSoal = Loadable(() => import('../views/Ujian/UjiKerja/PerSoal'));
// const Ikhtisar = Loadable(() => import('../views/Ujian/UjiKerja/Ikhtisar'));
const HasilUjian = Loadable(() => import('../views/Ujian/HasilUjian/HasilUjian'));

const ProfilMurid = Loadable(() => import("../templates/Profil/ProfilMurid"));

export default [
	{ path: ['/profil'].join('/'), component: ProfilMurid },
	
	{	path: ['/ujian'].join('/'), component: DaftarUjian, },
	{	path: ['/ujian', ':sesi_id'].join('/'), component: UjiTunggu, header:false },
	{	path: ['/ujian', 'soal', ':sesi_id'].join('/'), component: PerSoal, header:false },
	// {	path: ['/ujian', 'ikhtisar', ':sesi_id'].join('/'), component: Ikhtisar, header:false },
	{	path: ['/ujian', 'hasil', ':sesi_id'].join('/'), component: HasilUjian, header:false },
];